import { apiClient } from './api-client';
import type { PipelineConfig, PipelineTemplate, OwnedStagesSummary, Candidate } from '@recruitai/shared';

export const pipelineApi = {
  // Pipeline Config
  getPipelineConfig: (jobId: string) =>
    apiClient.get<PipelineConfig>(`/jobs/${jobId}/pipeline`),

  updatePipelineConfig: (jobId: string, config: PipelineConfig) =>
    apiClient.put<PipelineConfig>(`/jobs/${jobId}/pipeline`, config),

  // Stage transitions
  moveCandidateStage: (jobId: string, candidateId: string, toStageId: string) =>
    apiClient.patch<Candidate>(`/jobs/${jobId}/candidates/${candidateId}/stage`, { toStageId }),

  // Templates
  listTemplates: () =>
    apiClient.get<PipelineTemplate[]>('/pipeline-templates'),

  createTemplate: (name: string, stages: PipelineConfig['stages']) =>
    apiClient.post<PipelineTemplate>('/pipeline-templates', { name, stages }),

  deleteTemplate: (templateId: string) =>
    apiClient.delete<void>(`/pipeline-templates/${templateId}`),

  // Owned stages
  getOwnedStages: () =>
    apiClient.get<OwnedStagesSummary[]>('/my-owned-stages'),

  // Candidate email
  sendCandidateEmail: (jobId: string, candidateId: string, subject: string, body: string) =>
    apiClient.post<void>(`/jobs/${jobId}/candidates/${candidateId}/email`, { subject, body }),
};
